export default "__VITE_ASSET__ec38fc93__"